/**
 * @file: latestWorkday.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import addDays from 'date-fns/addDays';
import startOfToday from 'date-fns/startOfToday';

export function latestWorkday(startWorkingHour = 9) {
  const today = new Date();
  if (today.getHours() < startWorkingHour) return addDays(startOfToday(), -1);
  return startOfToday();
}
